export const getApiUrl = (
  path: string,
  queryParams?: Record<string, string | number | boolean | undefined>
): string => {
  // Get the API base URL from environment variable or use a default
  const apiBaseUrl =
    process.env.REACT_APP_API_URL || "https://api.unspokenn.com";

  // Remove any leading slash from the path to avoid double slashes
  const cleanPath = path.startsWith("/") ? path.substring(1) : path;

  // Construct the base URL
  let url = `${apiBaseUrl}/api/${cleanPath}`;

  // Add query parameters if provided
  if (queryParams && Object.keys(queryParams).length > 0) {
    const searchParams = new URLSearchParams();

    Object.entries(queryParams).forEach(([key, value]) => {
      // Only add the parameter if it's defined
      if (value !== undefined) {
        searchParams.append(key, String(value));
      }
    });

    const queryString = searchParams.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
  }

  // Return the complete URL
  return url;
};
